var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 7.3125H8.4375M5.0625 9.5625H6.9525M11.0625 7.3125H12.9375V9.9375H11.0625V7.3125ZM3.5625 14.4375H14.4375C15.2659 14.4375 15.9375 13.7659 15.9375 12.9375V5.0625C15.9375 4.23407 15.2659 3.5625 14.4375 3.5625H3.5625C2.73407 3.5625 2.0625 4.23407 2.0625 5.0625V12.9375C2.0625 13.7659 2.73407 14.4375 3.5625 14.4375Z",
    stroke: "#FF7926",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.8a64e23938ec16e148c8eefa2e33967f.svg";
export { ForwardRef as ReactComponent };